import * as Yup from 'yup';

export const requirementsValidationSchema = Yup.object().shape({
  analysisRequirements: Yup.array().of(
    Yup.object().shape({
      content: Yup.string().trim().required('Enter requirement'),
      isMandatory: Yup.boolean().required(),
      weight: Yup.number().required(),
      id: Yup.string().nullable()
    })
  )
});
